import { useEffect, useState } from 'react';
import './style.scss';
import Checkbox from 'src/Admin/components/common/Checkbox';
import { useLocation } from 'react-router-dom';
import { formatMemberName } from 'src/Member/utils/common';
import Header from '../../../common/Header/Header';

import {
  AccordionUpArrow,
  AccordionDownArrow,
} from 'src/Admin/img/findcare/FindCareSVG';
import { useDispatch } from 'react-redux';
import useProfile from 'src/Admin/components/ViewMember/Profile/hooks/useProfile';
import { setSelectedMember } from 'src/redux/admin/memberModule';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import UserProfile from 'src/Admin/components/ViewMember/Profile/user-profile';
import { toast } from 'react-toastify';
import ToastMessage from 'src/Admin/components/common/ToastMessage';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';
import Dependents from 'src/Admin/components/ViewMember/Profile/Dependents';
import useDate from 'src/Member/utils/useDate';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import Skeleton from 'src/Admin/components/common/skeleton';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';

const getHeaderData = (name, heading) => {
  return (
    <div>
      <span className="text-capitalize">{name}</span>
      <span> {heading}</span>
    </div>
  );
};

const UpdateIcon = ({ className }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.27452 15.1109C1.89341 15.1109 1.56704 14.9753 1.29542 14.7041C1.02379 14.433 0.888211 14.1066 0.888673 13.725V4.02414C0.888673 3.64304 1.02449 3.31667 1.29611 3.04504C1.56774 2.77342 1.89387 2.63784 2.27452 2.6383H8.45884L7.073 4.02414H2.27452V13.725H11.9754V8.90924L13.3613 7.5234V13.725C13.3613 14.1062 13.2254 14.4325 12.9538 14.7041C12.6822 14.9758 12.3561 15.1114 11.9754 15.1109H2.27452ZM10.0179 3.03673L11.0053 4.00682L6.43205 8.5801V9.56752H7.40214L11.9927 4.97691L12.9802 5.947L8.38955 10.5376C8.26251 10.6646 8.11515 10.7658 7.94747 10.8411C7.77978 10.9164 7.60378 10.9538 7.41946 10.9534H5.73912C5.5428 10.9534 5.37811 10.8868 5.24507 10.7538C5.11203 10.6208 5.04574 10.4563 5.0462 10.2604V8.5801C5.0462 8.39532 5.08085 8.21909 5.15014 8.0514C5.21943 7.88372 5.3176 7.73659 5.44463 7.61001L10.0179 3.03673ZM12.9802 5.947L10.0179 3.03673L11.7502 1.30443C12.0274 1.02726 12.3595 0.888672 12.7466 0.888672C13.1338 0.888672 13.4599 1.02726 13.725 1.30443L14.6951 2.29184C14.9608 2.55746 15.0936 2.88082 15.0936 3.26193C15.0936 3.64304 14.9608 3.9664 14.6951 4.23202L12.9802 5.947Z"
      fill="none"
      className={className}
    />
  </svg>
);

const AffiliationCard = () => {
  const { formatDate } = useDate();
  const location = useLocation();
  const dispatch = useDispatch();
  const requestDataFromState = location?.state;
  const [selectedAffiliatedMember, setAffiliatedSelectedMember] = useState();
  const [showEditMemberContactDetails, setShowEditMemberContactDetails] =
    useState(false);
  const [showEditDependentContactDetails, setShowEditDependentContactDetails] =
    useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [updatedCoverage, setUpdateCoverage] = useState(false);
  const [
    selectedDualAffilationsCoverageOption,
    setSelectedDualAffilationsCoverageOption,
  ] = useState(null);

  const [activeId, setActiveId] = useState(null);
  const userType = 'Employee';

  const {
    loader,
    viewUserProfile,
    viewDependent,
    employeeInfo,
    employmentDetails,
    PhoneEmailInfo,
    residentialAddress,
    mailingAddress,
    selectedMember,
    dependentsData,
    fetchDependentsData,
    serverError,
  } = useProfile(true, true);

  useEffect(() => {
    setIsAPIFailed(false);
    const getAffiliationDetail = async () => {
      try {
        //getViewAffiliationConfiguration
        /*const responseEmployeeData = await axiosInstance.get(
          APIEndpoints.getViewAffiliationConfiguration() +
            requestDataFromState?.data?.Oid,
        );*/

        const responseEmployeeData = await axiosInstance.get(
          APIEndpoints.getViewAffiliationConfigurationV1() +
            requestDataFromState?.data?.Oid,
        );
        if (
          responseEmployeeData.status ===
            HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
          responseEmployeeData.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
        ) {
          const updatedAffiliatedCoverage = structuredClone(
            responseEmployeeData?.data?.Response,
          );
          updatedAffiliatedCoverage?.DualCoverageUserDetailsDTO?.DualCoverageAffiliation.forEach(
            (item) => (item.isSelected = false),
          );
          setAffiliatedSelectedMember(updatedAffiliatedCoverage);
        }
      } catch (error) {
        console.log('error123', error);
        setIsAPIFailed(true);
      }
    };
    getAffiliationDetail();
  }, [requestDataFromState?.data?.Oid]);

  const handleRequest = async (action) => {
    try {
      if (requestDataFromState?.selectedTabLocal === 'affiliation') {
        await axiosInstance.post(
          `${
            action === 'approve'
              ? APIEndpoints.dualCoverageApprove()
              : APIEndpoints.dualCoverageDenied()
          }/${requestDataFromState?.data?.Oid}`,
        );
      } else {
        await axiosInstance.post(
          `${APIEndpoints.approveEnrollmentRequest()}worklistoid/${
            requestDataFromState?.data?.Oid
          }/enrollmentoid/${requestDataFromState?.enrollmentOid}/status/${
            action === 'approve' ? 'Approved' : 'Denied'
          }`,
        );
      }
      toast.success(
        <ToastMessage
          type="success"
          subTitle={`${
            requestDataFromState?.selectedTabLocal
              ? 'Affiliation'
              : 'Enrollment'
          } request for ${name} has been ${
            action === 'approve' ? 'approved' : 'denied'
          }!`}
        />,
      );
    } catch (error) {
      toast.error(
        <ToastMessage
          type="error"
          subTitle={`${
            requestDataFromState?.selectedTabLocal === 'affiliation'
              ? 'Affiliation'
              : 'Enrollment'
          } request for ${name} could not be ${
            action === 'approve' ? 'approved' : 'denied'
          } at the moment! Try again later.`}
        />,
      );
    }
  };

  const approveRequest = () => handleRequest('approve');
  const denyRequest = () => handleRequest('deny');

  const toggleActive = (item, id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      dispatch(
        setSelectedMember({
          ID:
            item?.UserType === 'Member' ? item?.MemberOid : item?.DependentOid,
          mType: item?.UserType === 'Member' ? userType : item?.UserType,
        }),
      );
      setActiveId(id);
    }
  };

  const memberName = formatMemberName({
    FirstName: isAPIFailed
      ? requestDataFromState?.data?.firstName
      : selectedAffiliatedMember?.DualCoverageUserDetailsDTO?.FirstName,
    MiddleName:
      !isAPIFailed &&
      selectedAffiliatedMember?.DualCoverageUserDetailsDTO?.MiddleName,
    LastName: isAPIFailed
      ? requestDataFromState?.data?.LastName
      : selectedAffiliatedMember?.DualCoverageUserDetailsDTO?.LastName,
  });

  const updateChangeHandler = () => {
    setUpdateCoverage(true);
  };

  const cancelUpdateHandler = () => {
    setUpdateCoverage(false);
  };

  const onSelectHandler = (e, item) => {
    const selectedDualCoverage = structuredClone(selectedAffiliatedMember);
    selectedDualCoverage?.DualCoverageUserDetailsDTO?.DualCoverageAffiliation.forEach(
      (val) => {
        val.isSelected =
          (val?.UserType === 'Member' && val?.MemberOid === item?.MemberOid) ||
          (val?.UserType === 'Dependent' &&
            val?.DependentOid === item?.DependentOid)
            ? e.target.checked
            : false;
      },
    );

    setAffiliatedSelectedMember(selectedDualCoverage);
    const selectedCoverage =
      selectedDualCoverage?.DualCoverageUserDetailsDTO?.DualCoverageAffiliation?.filter(
        (item) => item.isSelected === true,
      );
    setSelectedDualAffilationsCoverageOption(selectedCoverage);
  };

  const dualUpdateCoverageHandler = async () => {
    const updatedDualCoveragesAffiliation =
      selectedDualAffilationsCoverageOption &&
      selectedDualAffilationsCoverageOption.map((item) => {
        return {
          [item?.UserType === 'Dependent' ? 'DependentOid' : 'MemberOid']:
            item?.UserType === 'Dependent'
              ? item?.DependentOid
              : item?.MemberOid,
          DefaultProfile: item?.DefaultProfile,
        };
      });

    const payload = {
      DualCoverageAddUser: {
        Oid: selectedAffiliatedMember?.DualCoverageUserDetailsDTO?.Oid,
        UserType:
          selectedAffiliatedMember?.DualCoverageUserDetailsDTO?.UserType,
        UserID: selectedAffiliatedMember?.DualCoverageUserDetailsDTO?.UserID,
        RRUserOID: '',
        FirstName:
          selectedAffiliatedMember?.DualCoverageUserDetailsDTO?.FirstName,
        MiddleName: '',
        LastName:
          selectedAffiliatedMember?.DualCoverageUserDetailsDTO?.LastName,
        Status: selectedAffiliatedMember?.DualCoverageUserDetailsDTO?.status,
        SuperUser:
          selectedAffiliatedMember?.DualCoverageUserDetailsDTO?.SuperUser,
        DisplayName:
          selectedAffiliatedMember?.DualCoverageUserDetailsDTO?.DisplayName,
        RegEmailSentDate: '',
        SubCategory: selectedAffiliatedMember?.Subcategory,
        DualCoverageAffiliation: updatedDualCoveragesAffiliation,
      },
    };
    try {
      const response = await axiosInstance.put(
        APIEndpoints.getUpdatedAffiliationConfiguration(),
        payload,
      );
      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        toast.success('Affiliated account(s) updated successfully.');
        setUpdateCoverage(false);
      }
    } catch (err) {
      toast.error('Affiliated account(s) is not updated.');
      console.log('err: ', err);
      setUpdateCoverage(true);
    }
  };

  console.log(
    'selectedAffiliatedMember',
    selectedAffiliatedMember,
    selectedDualAffilationsCoverageOption,
    serverError,
  );

  console.log('requestDataFromState', requestDataFromState);

  return (
    <div className="container-offset enrollment-request-details-container">
      <Header
        className="haeder"
        linkTo={'/admin/approvals'}
        header={getHeaderData(
          memberName,
          requestDataFromState?.data?.Subcategory,
        )}
        preserveData={{ tab: 'affiliation' }}
      />

      <div className="affliation-details-footer">
        Select the account which you want to Affilate
      </div>
      <div className="afflication-details-overview-card">
        <div className="afflication-details-block">
          <h1 className="details-block-heading">Affiliation Account</h1>
          {!isAPIFailed && (
            <div className="btn-container">
              <button className="Deny-btn" onClick={denyRequest}>
                DENY
              </button>
              <button className="Approve-btn" onClick={approveRequest}>
                APPROVE
              </button>
            </div>
          )}
        </div>
        {!isAPIFailed && (
          <div className="affiliation-button-container">
            <GenericButton variant="secondary" onClick={updateChangeHandler}>
              <span>
                <UpdateIcon className="update-svg-icons" />
              </span>
              <span className="button-space">UPDATE</span>
            </GenericButton>
          </div>
        )}
        {isAPIFailed ? (
          <CustomClientError
            ErrorHeading="Something went wrong with request!"
            ErrorMessage="Please try again."
            CustomClasses="p-0"
          />
        ) : selectedAffiliatedMember?.DualCoverageUserDetailsDTO
            ?.DualCoverageAffiliation ? (
          selectedAffiliatedMember?.DualCoverageUserDetailsDTO?.DualCoverageAffiliation.map(
            (item, index) => {
              return (
                <div key={item?.MemberOid} className="afflication-details-card">
                  <div className="afflication-detail-row">
                    <div
                      className="icon"
                      onClick={() => toggleActive(item, index)}
                    >
                      {activeId === index ? (
                        <AccordionUpArrow className="acc-arrow" />
                      ) : (
                        <AccordionDownArrow className="acc-arrow" />
                      )}
                    </div>
                    <Checkbox
                      //checked={!item?.isSelected}
                      isDisabled={!updatedCoverage}
                      onChange={(e) => onSelectHandler(e, item)}
                    />

                    <div className="detail-container">
                      <h4 className="heading">
                        {item?.LastName}, {item?.FirstName} ({item?.UserType})
                      </h4>
                      <div className="details">
                        <div className="content">
                          <p className="content-one">Employer</p>
                          <p className="content-two">{item?.Employername}</p>
                        </div>

                        <div className="content">
                          <p className="content-one">Request Type</p>
                          <p className="content-two">
                            {selectedAffiliatedMember?.Subcategory}
                          </p>
                        </div>
                        <div className="content">
                          <p className="content-one">Coverage Period</p>
                          <p className="content-two">
                            {formatDate(item?.DualCoverageEffectiveDate)} to{' '}
                            {item?.DualCoveragTerminationDate !== 'null' &&
                            item?.DualCoveragTerminationDate !== 'NULL' &&
                            item?.DualCoveragTerminationDate !== undefined
                              ? formatDate(item?.DualCoveragTerminationDate)
                              : 'Current'}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {activeId === index && (
                    <div>
                      <div className="affliation-card-profile"></div>
                      <div>
                        {serverError ? (
                          <CustomClientError
                            ErrorHeading="Something went wrong with request!"
                            ErrorMessage="Please try again."
                            CustomClasses="p-0"
                          />
                        ) : (
                          viewUserProfile &&
                          selectedMember.mType === 'Employee' && (
                            <>
                              <UserProfile
                                loader={loader}
                                employeeInfo={employeeInfo}
                                loggedInMemberType={selectedMember.mType}
                                loggedInUserOID={selectedMember.ID}
                                residentialAddress={residentialAddress}
                                mailingAddress={mailingAddress}
                                PhoneEmailInfo={PhoneEmailInfo}
                                employmentDetails={employmentDetails}
                                serverError={serverError}
                                onClickEdit={() => {
                                  setShowEditMemberContactDetails(true);
                                }}
                                showEditButton={false}
                              />
                              <Dependents
                                dependentsData={dependentsData}
                                fetchDependentsData={fetchDependentsData}
                                onClickEdit={() => {
                                  setShowEditDependentContactDetails(true);
                                }}
                                showEditButton={false}
                              />
                            </>
                          )
                        )}

                        {viewDependent &&
                          selectedMember.mType === 'Dependent' && (
                            <UserProfile
                              loader={loader}
                              employeeInfo={employeeInfo}
                              loggedInMemberType={selectedMember.mType}
                              loggedInUserOID={selectedMember.ID}
                              residentialAddress={residentialAddress}
                              mailingAddress={mailingAddress}
                              PhoneEmailInfo={PhoneEmailInfo}
                              employmentDetails={employmentDetails}
                              serverError={serverError}
                              onClickEdit={() => {
                                setShowEditMemberContactDetails(true);
                              }}
                              showEditButton={false}
                            />
                          )}
                      </div>
                    </div>
                  )}
                </div>
              );
            },
          )
        ) : (
          [1, 2, 3, 4].map((item) => (
            <Skeleton className="ml-2" key={item} width={1200} height={70} />
          ))
        )}

        {updatedCoverage && (
          <div className="affiliation-button-container">
            <GenericButton
              className="mr-3 px-4 py2"
              variant="secondary"
              onClick={cancelUpdateHandler}
            >
              Cancel
            </GenericButton>
            <GenericButton
              onClick={dualUpdateCoverageHandler}
              className="ml-1 px-4 py2"
            >
              Save
            </GenericButton>
          </div>
        )}
      </div>
    </div>
  );
};
export default AffiliationCard;
